<template>
  <div v-show="qrCode">
    <AppModal
      v-model="showModal"
      :show-save="false"
      cancel-text="Close"
      @cancel="handleClose"
      :has-contract-brand="true"
    >
      <div class="flex flex-col items-center relative">
        <h2 class="text-xl font-semibold mb-4">
          User Checkin QR Code
        </h2>

        <div class="relative" style="position: relative; z-index: 99999;">
          <img
            class="w-[225px] h-[225px] mb-4 relative"
            style="position: relative; z-index: 99999;"
            :src="qrCode"
            alt="QR Code"
          />
        </div>

        <div
          v-if="modalMessage"
          class="px-4 py-2 text-lg font-semibold text-center text-white"
        >
          {{ modalMessage }}
        </div>

        <div
          v-if="modalWarning"
          class="px-4 py-2 text-lg font-semibold text-center  text-white "
        >
          {{ modalWarning }}
        </div>
      </div>
    </AppModal>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, defineExpose } from "vue";
import { useUserProfileStore } from "@/store/UserProfile";
import useQRCode from "@/modules/useQRCode";
import AppModal from "@/components/AppModal.vue";
import AppButton from "@/components/AppButton.vue";

const emit = defineEmits(["close", "modal-closed", "modal-opened"]);

const props = defineProps({
  enableModal: { type: Boolean, required: false, default: true },
  modalMessage: { type: String, required: false },
  modalWarning: { type: String, required: false },
});

const { generateQRCode } = useQRCode();
const { profile } = useUserProfileStore();
const qrCode = ref<string>();
const showModal = ref(false);
const hasMessage = computed(() => props.modalMessage && props.modalMessage.length > 0);
const hasWarning = computed(() => props.modalWarning && props.modalWarning.length > 0);

const toggleShowModal = () => {
  showModal.value = !showModal.value;
  if (showModal.value) {
    emit("modal-opened");
  } else {
    emit("close");
    emit("modal-closed");
  }
};

const handleClose = () => {
  showModal.value = false;
  emit("close");
  emit("modal-closed");
};

const initalize = async () => {
  qrCode.value = await generateQRCode(profile.id);
};

initalize();

defineExpose({ toggleShowModal });
</script>